// Mock data for RK ROTOARC website

export const contactInfo = {
  phone: "9566030388",
  whatsapp: "9566030388",
  email: "rk.rotoarc1@gmail.com",
  address: "Chennai, Tamil Nadu, India",
  establishedYear: 2015
};

export const heroContent = {
  headline: "Powering the Backbone of Welding Industries",
  subheadline: "Premium Welding Equipment Built for Performance and Durability",
  heroImage: "https://images.unsplash.com/photo-1508465818649-14a170138405"
};

export const aboutContent = {
  title: "About RK ROTOARC",
  description: "RK ROTOARC is a trusted Indian welding equipment brand established with a vision to deliver world-class performance to fabrication workshops, construction sites, and industrial facilities. Since our trademark registration in 2015, we have been committed to providing premium quality welding equipment built with durable materials and engineered for heavy-duty industrial applications. Our deep understanding of the welding industry, combined with our focus on quality, durability, and reliability, makes us the preferred choice for professionals across India."
};

export const productCategories = [
  {
    id: 1,
    name: "Electrode Holders & Clamps",
    description: "Heavy-duty electrode holders with copper jaws and fire-safe insulation",
    image: "https://images.unsplash.com/photo-1563229708-55d0a600b01d",
    products: [
      "RK 789 Electrode Holder",
      "RK 999 Electrode Holder",
      "RK 99 Electrode Holder",
      "RK 333 Electrode Holder",
      "RK 777 Electrode Holder",
      "RK 77 Electrode Holder",
      "MINI BRASS Electrode Holder",
      "INSULATED CLAMP"
    ]
  },
  {
    id: 2,
    name: "ISI Cutting Equipment",
    description: "ISI certified gas regulators and cutting torches with forged brass body",
    image: "https://images.unsplash.com/photo-1641893823219-38b433f736c0",
    products: [
      "Single Gauge Regulator (ISI)",
      "Double Gauge Regulator (ISI)",
      "Gas Cutting Torch (ISI)",
      "N.M Cutting Torch (ISI)"
    ]
  },
  {
    id: 3,
    name: "Non-ISI Cutting Equipment",
    description: "Premium brass regulators, LPG regulators, and cutting accessories",
    image: "https://images.unsplash.com/photo-1726421690313-2e0519335b82",
    products: [
      "Single Gauge Regulator",
      "Double Gauge Regulator",
      "LPG Regulator (300g/400g)",
      "Gas Cutting Torch",
      "A Type Nozzle",
      "B Type Nozzle",
      "Flashback Arrestor"
    ]
  },
  {
    id: 4,
    name: "Personal Protective Equipment",
    description: "Industrial-grade safety equipment for welding professionals",
    image: "https://images.unsplash.com/photo-1508465818649-14a170138405",
    products: [
      "Safety Helmet with Flip Window",
      "Hand Shield",
      "Safety Shoes (Steel Toe, Anti-slip)"
    ]
  },
  {
    id: 5,
    name: "Drying Ovens",
    description: "Digital and manual welding electrode drying ovens",
    image: "https://images.unsplash.com/photo-1641893823219-38b433f736c0",
    products: [
      "Carry Oven (5kg capacity)",
      "Mother Oven 25kg (Digital Control)",
      "Mother Oven 40/75kg (Digital Control)"
    ]
  }
];

export const whyChooseUs = [
  {
    title: "Industrial Grade Quality",
    description: "Premium materials and precision engineering for demanding applications",
    icon: "Award"
  },
  {
    title: "Durable Copper & Brass Components",
    description: "Heavy-duty construction with forged brass and copper for long-lasting performance",
    icon: "Shield"
  },
  {
    title: "Designed for Heavy Duty Use",
    description: "Built to withstand continuous operation in harsh industrial environments",
    icon: "Wrench"
  },
  {
    title: "Reliable Performance",
    description: "Consistent quality and dependable operation for critical welding tasks",
    icon: "CheckCircle"
  },
  {
    title: "Trusted by Professionals",
    description: "The preferred choice of workshops and fabricators across India",
    icon: "Users"
  },
  {
    title: "Strong Dealer Network",
    description: "Extensive distribution network ensuring quick supply and support",
    icon: "Network"
  }
];

export const industries = [
  {
    name: "Construction",
    description: "Heavy-duty equipment for construction and infrastructure projects",
    icon: "Building2"
  },
  {
    name: "Infrastructure",
    description: "Reliable tools for large-scale infrastructure development",
    icon: "BrickWall"
  },
  {
    name: "Fabrication Workshops",
    description: "Professional-grade equipment for metal fabrication and manufacturing",
    icon: "Factory"
  },
  {
    name: "Shipbuilding",
    description: "Marine-grade welding solutions for shipyard applications",
    icon: "Ship"
  },
  {
    name: "Manufacturing Plants",
    description: "Industrial equipment for production facilities and assembly lines",
    icon: "Cog"
  },
  {
    name: "Repair & Maintenance",
    description: "Durable tools for maintenance workshops and repair facilities",
    icon: "Wrench"
  }
];

export const dealerBenefits = [
  "High demand welding products with proven market acceptance",
  "Competitive dealer margins and attractive pricing structure",
  "Comprehensive product training and technical support",
  "Fast and reliable supply chain management",
  "Marketing support and promotional materials",
  "Growing brand with strong industrial presence"
];
